
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsProvider";
import { Link } from "react-router-dom";
import "./StaticPage.css";

function SitemapPage() {
    const { settings } = useSettings();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="main-content">
            <Helmet>
                <title>Sitemap - {settings?.site_name || "Play Store"}</title>
                <meta name="description" content="Complete sitemap of all pages and sections" />
            </Helmet>

            <div className="static-page-container">
                <div className="page-header">
                    <h1>Sitemap</h1>
                    <p className="page-subtitle">Navigate through all sections of {settings?.site_name}</p>
                </div>

                <div className="page-content">
                    <div className="sitemap-grid">
                        <section className="sitemap-section">
                            <h2>📱 Apps & Games</h2>
                            <ul className="sitemap-links">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/apps">Apps</Link></li>
                                <li><Link to="/games">Games</Link></li>
                                <li><Link to="/categories">Categories</Link></li>
                                <li><Link to="/top-charts">Top Charts</Link></li>
                                <li><Link to="/latest">Latest</Link></li>
                                <li><Link to="/recommended">Recommended</Link></li>
                            </ul>
                        </section>

                        <section className="sitemap-section">
                            <h2>📝 Blog</h2>
                            <ul className="sitemap-links">
                                <li><Link to="/blogs">All Blogs</Link></li>
                                <li><Link to="/blogs/categories">Blog Categories</Link></li>
                                <li><Link to="/blogs/featured">Featured Posts</Link></li>
                                <li><Link to="/blogs/latest">Latest Posts</Link></li>
                                <li><Link to="/blogs/popular">Popular Posts</Link></li>
                            </ul>
                        </section>

                        <section className="sitemap-section">
                            <h2>👤 User</h2>
                            <ul className="sitemap-links">
                                <li><Link to="/login">Login</Link></li>
                                <li><Link to="/register">Register</Link></li>
                                <li><Link to="/profile">Profile</Link></li>
                                <li><Link to="/wishlist">Wishlist</Link></li>
                            </ul>
                        </section>

                        <section className="sitemap-section">
                            <h2>💼 Company</h2>
                            <ul className="sitemap-links">
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/developers">Developers</Link></li>
                                <li><Link to="/press">Press</Link></li>
                                <li><Link to="/careers">Careers</Link></li>
                            </ul>
                        </section>

                        <section className="sitemap-section">
                            <h2>🛟 Support</h2>
                            <ul className="sitemap-links">
                                <li><Link to="/help">Help Center</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                                <li><Link to="/faqs">FAQs</Link></li>
                                <li><Link to="/report-bug">Report a Bug</Link></li>
                            </ul>
                        </section>

                        <section className="sitemap-section">
                            <h2>📜 Policies</h2>
                            <ul className="sitemap-links">
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/terms-of-service">Terms of Service</Link></li>
                                <li><Link to="/content-policy">Content Policy</Link></li>
                                <li><Link to="/family-policy">Family Policy</Link></li>
                                <li><Link to="/developer-policy">Developer Policy</Link></li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default SitemapPage;
